import { parseContent } from "@/lib/articles";

export default function ArticleBody({ content }: { content: string }) {
  const blocks = parseContent(content);

  return (
    <div className="prose-article text-[15px] leading-relaxed text-foreground-800">
      {blocks.map((block, index) => {
        if (block.type === "heading") {
          return (
            <h2
              key={index}
              className="mt-8 mb-3 font-heading text-lg font-bold text-foreground-950 md:text-xl"
            >
              {block.text}
            </h2>
          );
        }
        if (block.type === "quote") {
          return (
            <blockquote
              key={index}
              className="my-6 border-l-4 border-primary-400 bg-background-100 px-5 py-4 font-heading text-base text-foreground-800"
            >
              <i className="ri-double-quotes-l mr-1 text-primary-400"></i>
              {block.text}
            </blockquote>
          );
        }
        if (block.type === "list") {
          return (
            <ul key={index} className="my-5 space-y-2.5">
              {block.items?.map((item, itemIndex) => (
                <li key={itemIndex} className="flex items-start gap-2.5 text-foreground-800">
                  <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-accent-500"></span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          );
        }
        return (
          <p key={index} className="mb-4">
            {block.text}
          </p>
        );
      })}
    </div>
  );
}